// client/src/App.js
import React from 'react';
import CalendarCard from './components/CalendarCard';

function App() {
  return (
    <div>
      <CalendarCard />
    </div>
  );
}

export default App;
